import React, { useState } from 'react';
import { LegalModal } from './LegalModal';
export function Footer() {
  const [showPrivacy, setShowPrivacy] = useState(false);
  const [showTerms, setShowTerms] = useState(false);
  return <>
      <footer className="bg-navy-dark text-cream/40 py-10 px-6 text-center text-sm" data-id="element-73">
        <div className="max-w-4xl mx-auto" data-id="element-74">
          <p className="font-serif text-lg text-cream/60 mb-3" data-id="element-75">
            Cuna de Hierro
          </p>
          <p className="mb-4" data-id="element-76">
            © {new Date().getFullYear()} Cuna de Hierro. Todos los derechos
            reservados.
          </p>
          <div className="flex items-center justify-center gap-6" data-id="element-77">
            <button onClick={() => setShowPrivacy(true)} className="text-cream/50 hover:text-gold transition-colors cursor-pointer underline underline-offset-2" data-id="element-78">
              Política de Privacidad
            </button>
            <span className="text-cream/20" data-id="element-79">|</span>
            <button onClick={() => setShowTerms(true)} className="text-cream/50 hover:text-gold transition-colors cursor-pointer underline underline-offset-2" data-id="element-80">
              Términos y Condiciones
            </button>
          </div>
        </div>
      </footer>

      {/* Privacy Policy Modal */}
      <LegalModal isOpen={showPrivacy} onClose={() => setShowPrivacy(false)} title="Política de Privacidad" data-id="element-81">
        <p className="font-semibold text-navy" data-id="element-82">
          Última actualización: Abril 2026
        </p>

        <h3 className="font-serif font-bold text-navy text-lg mt-4" data-id="element-83">
          1. Información que Recopilamos
        </h3>
        <p data-id="element-84">
          Recopilamos la información personal que nos proporcionas
          voluntariamente al realizar una compra, incluyendo: nombre, dirección
          de correo electrónico y datos de pago. No almacenamos información de
          tarjetas de crédito directamente; todos los pagos son procesados por
          plataformas de pago seguras y cifradas.
        </p>

        <h3 className="font-serif font-bold text-navy text-lg mt-4" data-id="element-85">
          2. Uso de la Información
        </h3>
        <p data-id="element-86">Utilizamos tu información personal para:</p>
        <ul className="list-disc list-inside space-y-1 ml-2" data-id="element-87">
          <li data-id="element-88">Procesar y entregar tu compra digital.</li>
          <li data-id="element-89">Enviarte el producto adquirido a tu correo electrónico.</li>
          <li data-id="element-90">
            Comunicarnos contigo sobre actualizaciones del producto, si aplica.
          </li>
        </ul>

        <h3 className="font-serif font-bold text-navy text-lg mt-4" data-id="element-91">
          3. Protección de Datos
        </h3>
        <p data-id="element-92">
          Implementamos medidas de seguridad técnicas y organizativas para
          proteger tu información personal contra acceso no autorizado, pérdida
          o alteración. Utilizamos cifrado SSL en todas las transacciones.
        </p>

        <h3 className="font-serif font-bold text-navy text-lg mt-4" data-id="element-93">
          4. Compartir Información
        </h3>
        <p data-id="element-94">
          No vendemos, intercambiamos ni transferimos tu información personal a
          terceros, excepto a proveedores de servicios de pago necesarios para
          completar tu transacción.
        </p>

        <h3 className="font-serif font-bold text-navy text-lg mt-4" data-id="element-95">
          5. Cookies
        </h3>
        <p data-id="element-96">
          Nuestro sitio puede utilizar cookies para mejorar tu experiencia de
          navegación y analizar el tráfico del sitio. Puedes desactivar las
          cookies en la configuración de tu navegador.
        </p>

        <h3 className="font-serif font-bold text-navy text-lg mt-4" data-id="element-97">
          6. Tus Derechos
        </h3>
        <p data-id="element-98">
          Tienes derecho a acceder, rectificar o eliminar tu información
          personal en cualquier momento. Para ejercer estos derechos, puedes
          contactarnos a través de los canales disponibles en nuestro sitio.
        </p>
      </LegalModal>

      {/* Terms & Conditions Modal */}
      <LegalModal isOpen={showTerms} onClose={() => setShowTerms(false)} title="Términos y Condiciones" data-id="element-99">
        <p className="font-semibold text-navy" data-id="element-100">
          Última actualización: Abril 2026
        </p>

        <h3 className="font-serif font-bold text-navy text-lg mt-4" data-id="element-101">
          1. Aceptación de los Términos
        </h3>
        <p data-id="element-102">
          Al acceder y realizar una compra en este sitio web, aceptas cumplir
          con estos Términos y Condiciones. Si no estás de acuerdo con alguna
          parte de estos términos, te recomendamos no realizar la compra.
        </p>

        <h3 className="font-serif font-bold text-navy text-lg mt-4" data-id="element-103">
          2. Producto Digital
        </h3>
        <p data-id="element-104">
          "Cuna de Hierro" es un producto digital (guía en formato PDF) que se
          entrega por descarga inmediata tras la confirmación del pago. El
          contenido es de carácter informativo y educativo, y no sustituye el
          consejo médico profesional.
        </p>

        <h3 className="font-serif font-bold text-navy text-lg mt-4" data-id="element-105">
          3. Uso del Producto
        </h3>
        <p data-id="element-106">
          La guía es para uso personal y no comercial. Queda prohibida la
          reproducción, distribución, modificación o reventa del contenido sin
          autorización expresa por escrito.
        </p>

        <h3 className="font-serif font-bold text-navy text-lg mt-4" data-id="element-107">
          4. Política de Reembolso
        </h3>
        <p data-id="element-108">
          Debido a la naturaleza digital del producto y su entrega inmediata,
          todas las ventas son finales. No se ofrecen reembolsos una vez que el
          producto ha sido descargado o el enlace de descarga ha sido enviado.
        </p>

        <h3 className="font-serif font-bold text-navy text-lg mt-4" data-id="element-109">
          5. Descargo de Responsabilidad
        </h3>
        <p data-id="element-110">
          La información contenida en "Cuna de Hierro" se proporciona con fines
          educativos. Los resultados pueden variar según cada bebé y situación
          familiar. Siempre consulta con tu pediatra antes de implementar
          cambios significativos en la rutina de sueño de tu bebé.
        </p>

        <h3 className="font-serif font-bold text-navy text-lg mt-4" data-id="element-111">
          6. Propiedad Intelectual
        </h3>
        <p data-id="element-112">
          Todo el contenido, incluyendo textos, gráficos, logotipos e imágenes,
          es propiedad de Cuna de Hierro y está protegido por las leyes de
          propiedad intelectual aplicables.
        </p>

        <h3 className="font-serif font-bold text-navy text-lg mt-4" data-id="element-113">
          7. Modificaciones
        </h3>
        <p data-id="element-114">
          Nos reservamos el derecho de modificar estos Términos y Condiciones en
          cualquier momento. Las modificaciones entrarán en vigor inmediatamente
          después de su publicación en el sitio web.
        </p>
      </LegalModal>
    </>;
}